/**
 * The way back out of a screen: an arrow, in the top left corner.
 *
 * **An arrow and nothing else.** A back arrow in the top left is the one
 * control every person already knows, on every site and every phone they use.
 * Spelling it out tells somebody who already understood something they did not
 * need, and the words sit where the screen's own title should start.
 *
 * **It still carries its words for a screen reader.** The arrow is a drawing,
 * so the destination goes in the accessible name. An icon-only control with no
 * name announces itself as nothing, and that name is what the browser harness
 * finds it by, so a missing one fails the build.
 *
 * **This is only for the corner.** A button inside the content that happens to
 * go backwards is a different thing and keeps its words: "Back to
 * benchmarking" at the end of a finished run, or in an empty state, is telling
 * somebody where to go next rather than offering the way out of where they
 * are. An arrow in the middle of a page says nothing at all.
 */
export function BackButton({ to, onClick }: {
  /** Where it goes, in words, for the accessible name: "Back to {to}". */
  to: string
  onClick: () => void
}) {
  return (
    <button type="button" className="backbtn" aria-label={`Back to ${to}`} onClick={onClick}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
    </button>
  )
}
